import React, { useState } from 'react';
import { projects } from '../data/mock';
import { Reveal } from '../components/Reveal';

const Portfolio = () => {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Leasing', 'Sales', 'Services', 'MRO'];

  const filteredProjects = filter === 'All' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <div className="min-h-screen bg-slate-950 pt-20">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1764547168984-f1eae13ef38e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhdmlhdGlvbiUyMGFpcmNyYWZ0fGVufDB8fHx8MTc3MTA0NTY1OHww&ixlib=rb-4.1.0&q=85"
            alt="Portfolio"
            className="w-full h-full object-cover opacity-30"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Reveal y={30}>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">Our Portfolio</h1>
            <p className="text-xl md:text-2xl text-slate-300 max-w-3xl mx-auto">
              Showcasing our successful projects and partnerships
            </p>
          </Reveal>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal y={24} className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                className={`px-6 py-2.5 rounded-lg font-medium transition-all duration-200 ${
                  filter === category
                    ? 'btn-chrome shadow-lg'
                    : 'bg-slate-800 text-slate-300 hover:bg-slate-700 hover:text-white'
                }`}
              >
                {category}
              </button>
            ))}
          </Reveal>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project, index) => (
              <Reveal
                key={project.id}
                delay={(index % 3) * 0.1}
                className="group bg-slate-900 rounded-xl overflow-hidden border border-slate-800 hover:border-slate-700 transition-all duration-300 hover:shadow-2xl hover:shadow-slate-700/20 hover:-translate-y-2"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent"></div>
                  <div className="absolute top-4 right-4">
                    <span className="px-3 py-1 bg-slate-900/90 backdrop-blur-sm text-slate-300 text-sm rounded-full font-medium">
                      {project.category}
                    </span>
                  </div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <span className="text-sm font-medium">{project.year}</span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-slate-300 transition-colors duration-200">
                    {project.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    {project.description}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>

          {filteredProjects.length === 0 && (
            <div className="text-center py-12">
              <p className="text-slate-400 text-lg">No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Project Impact</h2>
            <p className="text-xl text-slate-400 max-w-2xl mx-auto">
              Delivering measurable results for our clients
            </p>
          </Reveal>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { value: '100+', label: 'Completed Projects' },
              { value: '50+', label: 'Aircraft Delivered' },
              { value: '30+', label: 'Global Partners' },
              { value: '98%', label: 'Client Satisfaction' }
            ].map((stat, index) => (
              <Reveal key={index} delay={index * 0.08} className="text-center group">
                <div className="text-5xl md:text-6xl font-bold text-chrome mb-3 group-hover:scale-110 transition-transform duration-300">
                  {stat.value}
                </div>
                <div className="text-slate-400 text-base md:text-lg">{stat.label}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
